import { Text } from '@procurify/ui'
import styled from 'styled-components'

export const CatalogItemDetailsAnalysisTextStyled = styled(Text)`
  white-space: pre-wrap;
`
